module.exports = __webpack_public_path__ + "img/magnifying-glass-solid.f86f8524.svg";